<template>
  <ion-page id="lichessmenu-page">
    <ion-content>

      <div v-if="showState == SHOW_EXPLAINTOUR">
        <ExplainTour :screen="explainTourScreen"
                      :wordsSpoken="explainTourWordsSpoken"
                      :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                    @toolbar-click="explainTourToolbarClick" />

      </div>

      <div v-if="showState == SHOW_SINGLE_OPTION">
        <SingleOption :displayArray="singleOptionArray"
                        :descriptionHeading="singleOptionHeading"
                        :initialSelected="singleOptionSelected"
                        :wordsSpoken="singleOptionWordsSpoken"
                        :wordsSpokenTrigger="singleOptionWordsSpokenTrigger"

                        @item-selected="singleOptionClick" 
                        @toolbar-click="singleOptionToolbarClick"/>
      </div>

      <div v-show="showState == SHOW_MENU">
        <TopLine :style="styleTopline" :title="playLichessTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>
        <ion-list :style="styleMiddle" class="ion-no-padding" id="lichess-menu">
        
          <ion-item v-if="lichessAccessToken.length == 0">
            <ion-label color="danger">
              <h1>*** You Must Connect to Lichess First ***</h1>
            </ion-label>
          </ion-item>
          <ion-item  v-for="item in menuItems" v-bind:key="item.index" @click="onClick(item.index)">
            <ion-label>
              {{ item.label }}
            </ion-label>
          </ion-item>
        </ion-list>
        <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
      </div>
    </ion-content>
  </ion-page>
  
</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';
  
  import { computed } from "@vue/reactivity"

  import { ref, watch } from 'vue'
  import ExplainTour from '@/components/ExplainTour.vue'
  import ToolBar from '@/components/ToolBar.vue'
  import TopLine from '@/components/TopLine.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { v4 as uuidv4 } from 'uuid';
  import { useGetData ,getLichessData , generateErrorAlertText} from '../../composables/getData.js'
  import SingleOption from '@/components/SingleOption.vue'
  import { buildWordListFromChoiceList , matchValue, parseGeneralWordsSaid } from '@/composables/wordlistSupport.js'

   import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { translateEnglishWords , translatePhrase} from '@/composables/translation.js';

const emit = defineEmits(['where-next','word-list','mic-is-muted'])

const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const isMe = connectionStore.getIsMe
  const isDark = ref(connectionStore.getDarkmode != "light")

  var lichessTokenIsValid = true

  const lichessAccessToken = ref(connectionStore.getLichessAccessToken)

  //console.log("access token in lichess menu",lichessAccessToken.value)
  const wordlistExplain = "command done"
  const wordlistTrigger = ref(0)

  const singleOptionWordsSpoken = ref("")
  const singleOptionWordsSpokenTrigger = ref(0)

  const wordlistMenu = "command scroll up down done back explain connect disconnect rapid correspondence open games game challenge arena robot mute listen";
    
  const wordlist = ref(wordlistMenu)
  emit("word-list",wordlist.value)

  const playLichessTitle = translateEnglishWords("Play Lichess")
  const menuStrings = [ 
    translateEnglishWords("Connect to Lichess"), 
    "'" + translateEnglishWords("Rapid") + "' " + translateEnglishWords("Pairing"),
    "'" + translateEnglishWords("Correspondence") + "' " + translateEnglishWords("Pairing"),
    translateEnglishWords("Challenge Friend"),
    translateEnglishWords("Arena Tournaments"), 
    translateEnglishWords("Open Games List")
  ]
  const menuKeyWords = ["connect", "rapid pair" , "correspondence pair" , 
                      "challenge friend" , 
                      "arena tournament" , "open games"]

  if (isMe) {
    menuStrings.push(translateEnglishWords("Robot Robot Challenge"))
    menuKeyWords.push("robot robot challenge")
  }

  const menuItems = ref([])

  const SHOW_MENU = 0
  const SHOW_EXPLAINTOUR = 1
  const SHOW_SINGLE_OPTION = 2
  const showState = ref(SHOW_MENU)

  const TOOLBAR_EXPLAINTOUR = 0

  const toolbarElements = ref([
    { index : TOOLBAR_EXPLAINTOUR, label : translateEnglishWords("Explain") ,disabled : false},
  ])
 
  const toolbarTrigger = ref(0)
  
  const singleOptionHeading = ref("")
  const singleOptionArray = ref([])
  var singleOptionDisplayWordsArray = []
  var useSingleOptionDisplayWords = ""
  const singleOptionSelected = ref("")

  var scrollCounter = 0
  const scrollTrigger = ref(0)
  const explainScrollTrigger = ref(0)

  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")
  const explainTourWordsSpokenTrigger = ref(0)


   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  doStartupCheck(true,afterStartupCallbackRoutine)

  function afterStartupCallbackRoutine(stuffChanged) {
    //checkLichessToken()
    buildMenu()
    showState.value = SHOW_MENU
  }
  
  function buildMenu() {

    lichessAccessToken.value = connectionStore.getLichessAccessToken
    //console.log("in build menu ",lichessAccessToken.value)
    lichessTokenIsValid = true

    menuItems.value = []
    if (lichessAccessToken.value != "")
      menuItems.value.push({index : 0, label: translateEnglishWords("Disconnect")})
    else
      if (lichessTokenIsValid == false)
        menuItems.value.push( { index : 0, label : 
                translateEnglishWords("Connect") + " " + translatePhrase("To Lichess - (Access expired)") })
      else
        menuItems.value.push( { index : 0, label : menuStrings[0]})
    
    for (var i=1; i < menuStrings.length; i++)
      menuItems.value.push( { index : i, label : menuStrings[i]})
  }

 function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break
    }
  }


  // START Explain Tour Routines

  function explainTourInitialize(html) {
    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value = (html == null) ? "lichess_menu" : html;
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
  }

  function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_MENU
        wordlist.value = wordlistMenu
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        break
    }
  }

  // END Explain Tour Routines

  function singleOptionToolbarClick(selected) {
    //console.log("single option toolbar click",selected)
    toolbarTrigger.value++
    switch (selected) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize("options_single",null)
        break
      case "done" :
        //console.log("in done for single" ,singleOptionSelected.value)
        if (singleOptionSelected.value == "1") {
          //console.log("**** DISCONNECT")
          getDisconnect()
        }
        else {
          //console.log("**** NO DISCONNECT")
          switchToMenu()
        }
        break
    }
  }

  function toolbarClick(arrayIndex) {
      processWords("command explain")
  }

  function onClick(index) {
    //console.log("on click",index,lichessAccessToken.value,lichessAccessToken.value.length)
    if (index == 0) {
      if (lichessAccessToken.value == "")
        processWords("command connect")
      else
        processWords("command disconnect")
    }
    else
      processWords("command " + menuKeyWords[index])
  }

  function switchToMenu() {
    showState.value = SHOW_MENU
    wordlist.value = wordlistMenu
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarTrigger.value++
  }

  function verifyDisconnect() {
    singleOptionHeading.value = "Disconnect from Lichess?"
    singleOptionArray.value = []
    singleOptionDisplayWordsArray = []
    singleOptionDisplayWordsArray.push("yes")
    singleOptionDisplayWordsArray.push("no")
    var oneDisplay = { index : 0, name : "Yes", id : 1,radio : "1" , words : "yes"}
    singleOptionArray.value.push(oneDisplay)
    oneDisplay = { index : 1, name : "No", id : 0,radio : "0" , words : "no"}
    singleOptionArray.value.push(oneDisplay)
    singleOptionSelected.value = "0"
    useSingleOptionDisplayWords = buildWordListFromChoiceList(singleOptionDisplayWordsArray)
    //console.log("****************** single option array",singleOptionArray.value)
    //console.log("****************** single option word list",useSingleOptionDisplayWords)

    wordlist.value = useSingleOptionDisplayWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarTrigger.value++
    showState.value = SHOW_SINGLE_OPTION
  }

  function singleOptionClick(index) {
    //console.log("**** SINGLE Option index",index)
    singleOptionSelected.value = singleOptionArray.value[index].radio
  }

  function processWordsForMenu(text) {
    //console.log("text in lichess Menu ",text)
    const returnArray = parseWordsSaid(text)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "scroll" :
        scrollElement("lichess-menu",returnArray[1])
        break
      case "explain" :
        const htmlPage = (lichessAccessToken.value == "") ? "lichess_menu_not_connected" : "lichess_menu_connected"
        explainTourInitialize(htmlPage)
        break;
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        emit("where-next","/")
        //router.replace("/")
        break;
      case "rapid" :
        if (lichessAccessToken.value == "") {
          explainTourInitialize("lichess_connect_first")
          break
        }
        connectionStore.setPlayType("rapid")
        emit("where-next","/lichesschallenge")
        //router.replace("/lichesschallenge")
        break
      case "friend" :
        if (lichessAccessToken.value == "") {
          explainTourInitialize("lichess_connect_first")
          break
        }
        emit("where-next","/lichessfriends")
        //router.replace("/lichessfriends")
        break
      case "correspondence" :
        if (lichessAccessToken.value == "") {
          explainTourInitialize("lichess_connect_first")
          break
        }
        connectionStore.setPlayType("correspondence")
        emit("where-next","/lichesschallenge")
        //router.replace("/lichesschallenge")
        break
      case "arena" :
        if (lichessAccessToken.value == "") {
          explainTourInitialize("lichess_connect_first")
          break
        }
        emit("where-next","/lichessarena")
        //router.replace("/lichessarena")
        break
      case "open" :
        if (lichessAccessToken.value == "") {
          explainTourInitialize("lichess_connect_first")
          break
        }
        emit("where-next","/lichessopen")
        //router.replace("/lichessopen")
        break
      case "bot" :
        if (lichessAccessToken.value == "") {
          explainTourInitialize("lichess_connect_first")
          break
        }
        connectionStore.setPlayType("bot")
        emit("where-next","/lichesschallenge")
        //router.replace("/lichesschallenge")
        break
      case "disconnect" :
        if (lichessAccessToken.value == "")
          break
        verifyDisconnect()
        break
      case "connect" :
        if (lichessAccessToken.value != "")
          break
        //console.log("******* DO CONNECT")
        emit("where-next","/lichessconnect")
        //router.replace("/lichessconnect")
        break
    }
  }

  function processWords(text) {
    switch (showState.value) {
      case SHOW_EXPLAINTOUR :
        explainTourWordsSpoken.value = text
        explainTourWordsSpokenTrigger.value++
        break;
      case SHOW_SINGLE_OPTION :
        singleOptionWordsSpoken.value = text
        singleOptionWordsSpokenTrigger.value++
        break
      case SHOW_MENU :
        processWordsForMenu(text)
        break
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "explain") {
            return ["explain",""]
        }
        if (currentWord == "listen") {
            return ["listen",""]
        }
        if (currentWord == "mute") {
            return ["mute",""]
        }
        if (currentWord == "done") {
            return ["done",""]
        }
        if (currentWord == "scroll") {
            if (nextWord == "up") {
                return ["scroll", "up"]
            }
            if (nextWord == "down") {
                return ["scroll", "down"]
            }
        }
        
        // add choices here
      
        if (currentWord == "connect") {
          if (lichessAccessToken.value == "") {
              return (["connect",""])
          }
          return (["ignore",""])
        }

        if (currentWord == "disconnect") {
            if (lichessAccessToken.value != "") {
                return (["disconnect",""])
            }
            return (["ignore",""])
        }
        if (currentWord == "rapid") {
            return ["rapid",""]
        }
        if (currentWord == "challenge") {
            return ["friend",""]
        }
        if (currentWord == "arena") {
            return ["arena",""]
        }
        if (currentWord == "correspondence") {
            return ["correspondence",""]
        }
        if (currentWord == "open") {
            return ["open",""]
        }
        if (currentWord == "robot" && nextWord == "robot" && nextNextWord == "challenge") {
            return ["bot",""]
        }

        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

  function parseWordsSaid(str) {
  
    const words = str.split(" ")

    //console.log("string ",str)
    //console.log("words",words,words.length)
    if (words.length == 0) {
        return ["ignore",""];
    }

    var currentWord = (words.length > 0) ? words[0] : "xyz"
    var nextWord = (words.length > 1) ? words[1] : "xyz"
    var nextNextWord = (words.length > 2) ? words[2] : "xyz"
          
    //console.log("current word",currentWord)

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }

        if (currentWord == "command") {
          let returnArray = parseCommands(words, i+1)
            return returnArray
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""]
  }

  function processLichessCheckTokenJsonResponse (json) {
    //console.log(" check token callback",json)

    if (json.hasOwnProperty(lichessAccessToken.value) == false) {
      lichessTokenIsValid = false
      lichessAccessToken.value = ""
      //console.log("no entry")
    }
    else {
      const userTokenInfo = json[lichessAccessToken.value]
      //console.log(userTokenInfo.userId)
      if (userTokenInfo.hasOwnProperty("userId")) 
        lichessTokenIsValid = true
      else {
        lichessTokenIsValid = false
        lichessAccessToken.value = ""
      }
    }
    connectionStore.setLichessAccessToken(lichessAccessToken.value)
    buildMenu()
    showState.value = SHOW_MENU
  }

  function checkLichessToken() {
    var formData = lichessAccessToken.value
    const urlStr = "https://lichess.org/api/token/test"
    getLichessData(urlStr, null,formData, processLichessCheckTokenJsonResponse) 
  }

  function processDisconnectJsonResponse (json) {
    //console.log(" in lichess disconnect callback",json)
    if (json.hasOwnProperty('error')) {
      explainTourInitialize("ERROR:" + generateErrorAlertText(json))
      return;
    }

    switchToMenu()
    // will get the updated and empty token and userid
    doStartupCheck(true,afterStartupCallbackRoutine)
  }

  function getDisconnect() {
    var formData = {
    }
    useGetData("get_lichess_disconnect.php", formData, processDisconnectJsonResponse)
  }

</script>

<style scoped>
 
</style>